import { FormattedMessage } from "react-intl";
import {
  ITaskAcceptRequestBody,
  ITaskAccountBody,
  ITaskDetail,
  ITaskItem,
  ITaskOperationSnapshot,
} from "../../../../models/Task";
import { ITextDetailBase } from "../../../../ui/TextDetail/module/constants";
import messages from "./messages";

export const createRequestDetailFieldList = (
  request: ITaskItem
): ITextDetailBase[] => {
  const reqDetailFieldList: ITextDetailBase[] = [
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelParentId} />,
      value: request.parent_id,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestLabelId} />,
      value: request.id,
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestBeneficiary} />,
      value: request.beneficiary && request.beneficiary,
    },
    {
      label: (
        <FormattedMessage {...messages.PanelDetailRequestBeneficiaryEmail} />
      ),
      value: request.beneficiary_email ? request.beneficiary_email : "",
    },
    {
      label: <FormattedMessage {...messages.PanelDetailRequestApplication} />,
      value: request.application,
    },
    {
      label: (
        <FormattedMessage {...messages.takeChargeFrom} values={{ val: "" }} />
      ),
      value: request.enrichment ? request.enrichment : "",
    },
  ];
  return reqDetailFieldList;
};

export const findTaskToOperate = (
  taskId: string,
  tasks: ITaskOperationSnapshot[]
): ITaskOperationSnapshot | undefined => {
  if (tasks.length > 1) {
    for (let i = 0; i < tasks.length; i++) {
      if (tasks[i].task_id === taskId) {
        return tasks[i];
      } else {
        return tasks[0];
      }
    }
  } else {
    return tasks[0];
  }
};

const emptyAccount: ITaskAccountBody = {
  accountType_name: undefined,
  code: undefined,
  display_name: undefined,
  dn: undefined,
  email: undefined,
  expire: undefined,
  id: undefined,
  isDefault: undefined,
  last_access_date: undefined,
  last_pwd_change: undefined,
  last_wrong_login: undefined,
  name: undefined,
  number_login_error: undefined,
  surname: undefined,
};

export const generateAcceptTaskChangedList = (req: ITaskDetail) => {
  if (!req) {
    return [];
  }
  const taskChangedList: ITaskAcceptRequestBody[] = [];
  if (req && req.taskDetails && Array.isArray(req.taskDetails)) {
    req.taskDetails.forEach((item) => {
      if (item.details) {
        const tempTaksChanged: ITaskAcceptRequestBody = {
          taskId: item.task_id,
        };
        if (item.details.fixedAttributes) {
          tempTaksChanged.account = emptyAccount;
          tempTaksChanged.account.id = item.account_id;
          tempTaksChanged.account.isDefault = Number(
            item.details.fixedAttributes["@fixed_isDefault"].newValue
          );
          tempTaksChanged.account.code =
            item.details.fixedAttributes["@fixed_code"].newValue;
        }
        if (item.details.remoteAttributes) {
          tempTaksChanged.account!.targetAttributes = [];
        }
        taskChangedList.push(tempTaksChanged);
      }
    });
  }

  return taskChangedList;
};
